module.exports = __webpack_public_path__ + "img/output-7.1c55a6ae.png";